module.exports = __webpack_public_path__ + "media/images/pages/commercial/pocstock-commercial-2-617a43485698faef0b547a039c01fb52.png";